import type { SetDeltaXYPayloadWithoutFrameWidth } from "./canvas-types";

import * as React from "react";

import { useEditorDispatch, useEditorSelector } from "@v1/store/store";

import {
  selectActiveCanvasWidth,
  setDeltaXY as setDeltaXYAction,
} from "./canvas-reducer";

export function useSetDeltaXY() {
  const dispatch = useEditorDispatch();
  const activeCanvasWidth = useEditorSelector(selectActiveCanvasWidth);
  const setDeltaXY = React.useCallback(
    (payload: SetDeltaXYPayloadWithoutFrameWidth) => {
      if (typeof payload === "function") {
        dispatch(
          setDeltaXYAction((deltaXY) => ({
            ...payload(deltaXY),
            frameWidth: activeCanvasWidth,
          })),
        );
      } else {
        dispatch(
          setDeltaXYAction({ ...payload, frameWidth: activeCanvasWidth }),
        );
      }
    },
    [dispatch, activeCanvasWidth],
  );
  return setDeltaXY;
}
